import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ItemService } from 'src/app/provider/item.service';

@Component({
  selector: 'kt-order-types',
  templateUrl: './order-types.component.html',
  styleUrls: ['./order-types.component.scss']
})
export class OrderTypesComponent implements OnInit {

  constructor(
    public itemService: ItemService,
    private changeDetect: ChangeDetectorRef
  ) {
  }

  @Input() ID: number;

  subs: Subscription[] = [];

  ngOnInit() {

  }

  async ngOnChanges(changes: { [propKey: string]: any }) {
    this.ID = changes.ID.currentValue;
    this.itemService.getData(this.ID, 'menu-item');

    this.itemService.record_change$.subscribe(async (resp) => {
      this.changeDetect.detectChanges();
    });
  }

  ngOnDestroy() {
    for (const item of this.subs) {
      item.unsubscribe();
    }
  }

  onChange() {
    const data = this.itemService.record_change$.getValue();
    this.itemService.putItem(data);
  }
  
}
